// NOTE: we assume onExpanded function does not contain any data which could change during re-render
export const portfolioStructurePropsAreEquals = (prevProps, nextProps) => {
  return prevProps.dashboardData.timestamp === nextProps.dashboardData.timestamp &&
    prevProps.expanded === nextProps.expanded
};